
import './App.css';
import NewPortfolio from './components/porfolio_updated/NewPortfolio';
import Router from './router';

function App() {
  return (
    <>
     <NewPortfolio />
      <Router/>
    </>
  );
}

export default App;
